export const FIRST_BLOCK_OFFSET_X = 30;
export const FIRST_BLOCK_OFFSET_Y = 120;
// Keep in sync with Camera.css (.camera top)
export const CAMERA_TOP_OFFSET = 47;
export const SPAWN_VERTICAL_RATIO = 0.35;

// Inverts createBlock's block.x = -x + offset
const worldPositionToSpawnOrigin = (blockPosition) => ({
    x: FIRST_BLOCK_OFFSET_X - blockPosition.x,
    y: FIRST_BLOCK_OFFSET_Y - blockPosition.y,
});

export const getSpawnOrigin = (panzone, spawnPosition) => {
    if (spawnPosition) return worldPositionToSpawnOrigin(spawnPosition);

    const { x: rawX, y: rawY, scale } = panzone.getTransform();
    const visibleWidth = window.innerWidth;
    const visibleHeight = window.innerHeight - CAMERA_TOP_OFFSET;
    return {
        x: (rawX - visibleWidth / 2) / scale,
        y: (rawY - visibleHeight * SPAWN_VERTICAL_RATIO) / scale,
    };
};
